(function () {
  'use strict';

  var BUTTON_SELECTOR = '[data-jmt-quickadd]';
  var pendingButton = null;
  var toastTimer = null;

  function clean(value) { return String(value || '').replace(/\s+/g, ' ').trim(); }
  function normalize(value) { return clean(value).toLowerCase().replace(/\bcut\b/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function sizeCode(value) { return clean(value).split(/\s+/)[0].toUpperCase(); }

  function preference() {
    return window.JMT_PREF && window.JMT_PREF.get ? window.JMT_PREF.get() || {} : {};
  }

  function complete(pref) {
    return Boolean(pref && (pref.pouchStyle || pref.cut) && (pref.waistSize || pref.size) && pref.thongStrapStyle);
  }

  function summary(pref) {
    var pouch = clean(pref.pouchStyle || pref.cut);
    var size = sizeCode(pref.waistSize || pref.size);
    var back = clean(pref.thongStrapStyle);
    return [pouch && pouch + ' pouch', size, back].filter(Boolean).join(' · ');
  }

  function setBusy(button, busy) {
    if (!button) return;
    button.disabled = Boolean(busy);
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
    button.classList.toggle('is-loading', Boolean(busy));
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load this product.');
      return response.json();
    });
  }

  function selectionsFor(product, pref) {
    var selections = {};
    var names = window.JMT_VARIANTS && window.JMT_VARIANTS.optionNames
      ? window.JMT_VARIANTS.optionNames(product)
      : (product.options || []).map(function (option) { return typeof option === 'string' ? option : option.name; });
    names.forEach(function (name) {
      var role = window.JMT_VARIANTS && window.JMT_VARIANTS.role ? window.JMT_VARIANTS.role(name) : '';
      if (!role) {
        var lower = clean(name).toLowerCase();
        if (lower.indexOf('pouch') !== -1 || lower.indexOf('cut') !== -1) role = 'pouchStyle';
        else if (lower.indexOf('waist') !== -1 || lower === 'size') role = 'waistSize';
        else if (lower.indexOf('strap') !== -1 || lower.indexOf('back') !== -1) role = 'thongStrapStyle';
      }
      if (role === 'pouchStyle') selections[name] = pref.pouchStyle || pref.cut;
      if (role === 'waistSize') selections[name] = pref.waistSize || pref.size;
      if (role === 'thongStrapStyle') selections[name] = pref.thongStrapStyle;
    });
    return selections;
  }

  function findVariant(product, pref) {
    var selections = selectionsFor(product, pref);
    if (window.JMT_VARIANTS && window.JMT_VARIANTS.findVariant) {
      return window.JMT_VARIANTS.findVariant(product, selections, { availableOnly: true, requireAll: true });
    }
    var names = (product.options || []).map(function (option) { return typeof option === 'string' ? option : option.name; });
    return (product.variants || []).find(function (variant) {
      if (!variant || variant.available === false) return false;
      return names.every(function (name, index) {
        var wanted = selections[name];
        var actual = variant.options ? variant.options[index] : variant['option' + (index + 1)];
        if (clean(name).toLowerCase().indexOf('size') !== -1) return sizeCode(wanted) === sizeCode(actual);
        return normalize(wanted) === normalize(actual);
      });
    }) || null;
  }

  function lineProperties(pref, product, variant) {
    var properties = {};
    if (pref.pouchAdjustment) properties['Pouch size adjustment'] = pref.pouchAdjustment;
    if (pref.backStrapAdjustment) properties['Thong strap length adjustment'] = pref.backStrapAdjustment;
    if (!window.JMT_PRODUCTION) return properties;
    var input = window.JMT_PRODUCTION.inputFromProductVariant(product, variant, {
      pouchAdjustment: pref.pouchAdjustment,
      backStrapAdjustment: pref.backStrapAdjustment
    });
    var result = window.JMT_PRODUCTION.withProductionProperties(properties, input);
    if (!result.ok) {
      var error = new Error(result.message || 'That fit is not available.');
      error.jmtUserMessage = result.message;
      throw error;
    }
    return result.properties;
  }

  function addItem(variantId, quantity, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity, properties: properties }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) throw new Error(payload.description || 'This fit could not be added.');
        return payload;
      });
    });
  }

  function refreshCartWithoutOpening(payload) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return false;
    if (!payload || !payload.sections || !payload.sections['cart-drawer'] || !payload.sections['cart-icon-bubble']) return false;
    try {
      drawer.renderContents(payload, { open: false });
      return true;
    } catch (error) {
      console.error('Quick Add could not refresh the cart drawer.', error);
      return false;
    }
  }

  function showToast(product, pref) {
    var toast = document.getElementById('jmt-quickadd-toast');
    if (!toast) return;
    var productNode = toast.querySelector('[data-jmt-quickadd-product]');
    var fitNode = toast.querySelector('[data-jmt-quickadd-fit]');
    if (productNode) productNode.textContent = clean(product.title).replace(/^mens thong underwear\s*[-–:]?\s*/i, '');
    if (fitNode) fitNode.textContent = summary(pref);
    toast.hidden = false;
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { toast.hidden = true; }, 5200);
  }

  function openQuickFit(button) {
    pendingButton = button;
    if (window.JMT_QUICK_FIT && typeof window.JMT_QUICK_FIT.open === 'function') {
      window.JMT_QUICK_FIT.open('collection_quick_add', { context: 'preference' });
    }
  }

  function execute(button) {
    if (!button || button.disabled) return;
    var handle = clean(button.getAttribute('data-product-handle'));
    var pref = preference();
    if (!complete(pref)) {
      openQuickFit(button);
      return;
    }
    if (!handle) return;
    setBusy(button, true);
    var product;
    var variant;
    fetchProduct(handle)
      .then(function (loadedProduct) {
        product = loadedProduct;
        variant = findVariant(product, pref);
        if (!variant) throw new Error('That saved fit is not available for this product.');
        return addItem(variant.id, Number(button.getAttribute('data-qty')) || 1, lineProperties(pref, product, variant));
      })
      .then(function (response) {
        if (window.JMT_FALL_TRACK) window.JMT_FALL_TRACK('jmt:quick_add', {
          product_id:String(product.id),product_title:product.title,product_handle:handle,
          variant_id:String(variant.id),quantity:Number(button.getAttribute('data-qty')) || 1,
          value:variant.price / 100 * (Number(button.getAttribute('data-qty')) || 1),
          source:button.closest('#jmt-fall-product') ? 'fall_product_popup' : 'fall_collection_quick_add'
        });
        setBusy(button, false);
        button.classList.add('jmt-quickadd--added');
        refreshCartWithoutOpening(response);
        showToast(product, pref);
        window.dispatchEvent(new CustomEvent('jmt:cart:refresh'));
        window.dispatchEvent(new CustomEvent('jmt:cart:changed'));
        window.setTimeout(function () { button.classList.remove('jmt-quickadd--added'); }, 1200);
      })
      .catch(function (error) {
        setBusy(button, false);
        var message = error && (error.jmtUserMessage || error.message) || 'Quick Add failed. Please try again.';
        button.setAttribute('data-jmt-error', message);
        window.alert(message);
      });
  }

  document.addEventListener('click', function (event) {
    var close = event.target.closest('[data-jmt-quickadd-toast-close]');
    if (close) {
      var toast = document.getElementById('jmt-quickadd-toast');
      if (toast) toast.hidden = true;
      return;
    }
    var button = event.target.closest(BUTTON_SELECTOR);
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    execute(button);
  }, true);

  window.addEventListener('jmt:quick-fit:saved', function (event) {
    if (!pendingButton || !event.detail || event.detail.context !== 'preference') return;
    var button = pendingButton;
    pendingButton = null;
    if (!complete(preference())) return;
    window.setTimeout(function () { execute(button); }, 0);
  });

  window.addEventListener('jmt:quick-fit:closed', function () {
    pendingButton = null;
  });
})();
